import { render, staticRenderFns } from "./MultiOrderableUserListSelector.vue?vue&type=template&id=6877bbbf&scoped=true&"
import script from "./MultiOrderableUserListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiOrderableUserListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiOrderableUserListSelector.vue?vue&type=style&index=0&id=6877bbbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877bbbf",
  null
  
)

export default component.exports